import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Collapse } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import ProdutoFrame from './ProdutoFrame';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const Panel = Collapse.Panel;


export const OPCOES_COMBO_ORIGEM = [
  { key: '0', label: '0 - NACIONAL, EXCETO AS INDICADAS NOS CÓDIGOS 3 A 5' },
  { key: '1', label: '1 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, EXCETO A INDICADA NO CÓDIGO 6' },
  { key: '2', label: '2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CÓDIGO 7' },
  { key: '3', label: '3 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 40% (QUARENTA POR CENTO)' },
  { key: '4', label: '4 - NACIONAL, CUJA PRODUÇÃO TENHA SIDO FEITA EM CONFORMIDADE COM OS PROCESSOS PRODUTIVOS BÁSICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67, E AS LEIS NºS 8.248/91, 8.387/91, 10.176/01 E 11.484/ 07' },
  { key: '5', label: '5 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)' },
  { key: '6', label: '6 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
  { key: '7', label: '7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
  { key: '8', label: '8 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 70%' },
]

export const OPCOES_COMBO_MODALIDADE = [
  { key: '0', label: '0 - MARGEM VALOR AGREGADO' },
  { key: '1', label: '1 - PAUTA VALOR' },
  { key: '2', label: '2 - PREÇO TABELADO MÁX. (VALOR)' },
  { key: '3', label: '3 - VALOR DA OPERAÇÃO' },
]

export const OPCOES_COMBO_CST_ICMS = [
  { key: '101', label: '101 - Tributada pelo Simples Nacional com permissão de crédito' },
  { key: '102', label: '102 - Tributada pelo Simples Nacional sem permissão de crédito' },
  { key: '103', label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta' },
  { key: '201', label: '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária' },
  { key: '202', label: '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária' },
  { key: '203', label: '203 - Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária' },
  { key: '300', label: '300 - Imune' },
  { key: '400', label: '400 - Não tributada pelo Simples Nacional' },
  { key: '500', label: '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação' },
  { key: '900', label: '900 - Outros' },
]

export const OPCOES_COMBO_CST_IPI = [
  { key: '00', label: '00 - ENTRADA COM RECUPERAÇÃO DE CRÉDITO' },
  { key: '01', label: '01 - ENTRADA TRIBUTADA COM ALÍQUOTA ZERO' },
  { key: '02', label: '02 - ENTRADA ISENTA' },
  { key: '03', label: '03 - ENTRADA NÃO-TRIBUTADA' },
  { key: '04', label: '04 - ENTRADA IMUNE' },
  { key: '05', label: '05 - ENTRADA COM SUSPENSÃO' },
  { key: '49', label: '49 - OUTRAS ENTRADAS' },
  { key: '50', label: '50 - SAÍDA TRIBUTADA' },
  { key: '51', label: '51 - SAÍDA TRIBUTADA COM ALÍQUOTA ZERO' },
  { key: '52', label: '52 - SAÍDA ISENTA' },
  { key: '53', label: '53 - SAÍDA NÃO-TRIBUTADA' },
  { key: '54', label: '54 - SAÍDA IMUNE' },
  { key: '55', label: '55 - SAÍDA COM SUSPENSÃO' },
  { key: '99', label: '99 - OUTRAS SAÍDAS' },
]

export const OPCOES_COMBO_CST_PIS = [
  { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
  { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
  { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
  { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
  { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
  { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
  { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OUTRAS OPERAÇÕES DE SAÍDA' },
  { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
  { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
  { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
  { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
  { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
  { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
  { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
  { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
  { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_COFINS = [
  { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
  { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
  { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
  { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
  { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
  { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
  { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
  { key: '49', label: '49 - OUTRAS OPERAÇÕES DE SAÍDA' },
  { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
  { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
  { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
  { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
  { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
  { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
  { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
  { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
  { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_IBS_CBS = [
  { key: '000', label: '000 - TRIBUTAÇÃO INTEGRAL' },
  { key: '010', label: '010 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES – OPERAÇÕES SETOR FINANCEIRO (INSERIDO)' },
  { key: '011', label: '011 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES REDUZIDAS EM 30% e 60% (INSERIDO)' },
  { key: '200', label: '200 - ALÍQUOTA ZERO OU REDUZIDA' },
  { key: '210', label: '210 - ALÍQUOTA REDUZIDA EM 50% E 70% COM REDUTOR DE BASE DE CÁLCULO' },
  { key: '220', label: '220 - ALÍQUOTA FIXA' },
  { key: '221', label: '221 - ALÍQUOTA FIXA PROPORCIONAL' },
  { key: '222', label: '222 - REDUÇÃO DE BASE DE CÁLCULO' },
  { key: '400', label: '400 - ISENÇÃO' },
  { key: '410', label: '410 - IMUNIDADE E NÃO INCIDÊNCIA' },
  { key: '510', label: '510 - DIFERIMENTO' },
  { key: '550', label: '550 - SUSPENSÃO' },
  { key: '620', label: '620 - TRIBUTAÇÃO MONOFÁSICA' },
  { key: '800', label: '800 - TRANSFERÊNCIA DE CRÉDITO' },
  { key: '810', label: '810 - AJUSTES' },
  { key: '820', label: '820 - TRIBUTAÇÃO EM DECLARAÇÃO DE REGIME ESPECÍFICO' },
  { key: '830', label: '830 - Exclusão de base de cálculo' },
]




export default class NotaFiscalItemForm extends Component {
  state = {
    editando: false,

    listaParTributacao: [],
    listaParCFOP: [],

    listaProdutos: [],

    OPCOES_COMBO_CFOP: [],

    registro: {}

  };


  componentDidUpdate(propsAnterior) {
    if (this.props.produtoSelecionado !== propsAnterior.produtoSelecionado) {
      // console.log('componentDidUpdate', this.props.produtoSelecionado)
      this.setState({
        registro: this.props.produtoSelecionado.registro,
        listaProdutos: this.props.produtoSelecionado.listaProdutos ? this.props.produtoSelecionado.listaProdutos : [],
        editando: this.props.produtoSelecionado.editando,
      }, () => {
        this.onBuscaCFOP();
        if (this.props.produtoSelecionado.registro.nfi_seq === 0) {
          this.onBuscaParametros();
        }
        this.forceUpdate()
      })
    };
  }


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }


  onBuscaParametros = () => {
    this.setState({ listaParTributacao: [], listaParCFOP: [] })

    axios.get('/parametros/parametros_nfe_tributacao')
      .then(response => {
        // console.log('onBuscaParametros', response.data)
        this.setState({
          listaParTributacao: response.data,
          registro: {
            ...this.state.registro,
            nfi_cfop: { key: response.data.pnfet_cfop ? String(response.data[0].pnfet_cfop) : String(this.props.produtoSelecionado.registro.nfi_cfop.key) },
            nficms_origem: { key: response.data.pnfet_origem_produto ? String(response.data.pnfet_origem_produto) : '0' },
            nficms_cst: { key: response.data.pnfet_cst_icms ? String(response.data.pnfet_cst_icms) : '' },
            nfipi_cst: { key: response.data.pnfet_cst_ipi ? String(response.data.pnfet_cst_ipi).padStart(2, '0') : '' },
            nfpis_cst: { key: response.data.pnfet_cst_pis ? String(response.data.pnfet_cst_pis).padStart(2, '0') : '' },
            nfcof_cst: { key: response.data.pnfet_cst_cofins ? String(response.data.pnfet_cst_cofins).padStart(2, '0') : '' },
            nfci_cst: { key: response.data.pnfet_cst_ibs_cbs ? String(response.data.pnfet_cst_ibs_cbs).padStart(3, '0') : '' },
            nfci_sit_trib_ibs_cbs: response.data.pnfet_sit_trib_ibs_cbs ? String(response.data.pnfet_sit_trib_ibs_cbs) : '',

            nficms_picms: response.data.pnfet_picms ? response.data.pnfet_picms : 0,
            nfipi_pipi: response.data.pnfet_pipi ? response.data.pnfet_pipi : 0,
            nfpis_ppis: response.data.pnfet_ppis ? response.data.pnfet_ppis : 0,
            nfcof_pcofins: response.data.pnfet_pcofins ? response.data.pnfet_pcofins : 0,

            nfci_pibs_mun: response.data.pnfet_pibs_mun ? response.data.pnfet_pibs_mun : 0,
            nfci_pibs_est: response.data.pnfet_pibs_est ? response.data.pnfet_pibs_est : 0,
            nfci_pcbs: response.data.pnfet_pcbs ? response.data.pnfet_pcbs : 0,
          },
        })
      }).catch(error => {
        console.error(error.response);
      })

    axios.get('/parametros/parametros_nfe_cfop')
      .then(response => {
        this.setState({
          listaParCFOP: response.data,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onBuscaCFOP = () => {
    this.setState({ OPCOES_COMBO_CFOP: [] })
    axios.get('/cfop/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_CFOP = data.map(regList => {
          return {
            key: String(regList.cfop_codigo),
            label: String(regList.cfop_codigo) + ' - ' + regList.cfop_descricao,
          }
        });
        this.setState({
          registro: {
            ...this.state.registro,
            nf_nat_oper: { key: '5102', label: '', },
          },
          OPCOES_COMBO_CFOP,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };



  onOK = () => {

    const { registro, listaProdutos } = this.state;

    if ((!registro.nfi_produto) || (registro.nfi_produto.key === '0') || (registro.nfi_produto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }
    if (!registro.nfi_ncm) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o NCM', });
      return;
    }
    if ((!registro.nfi_cfop) || (registro.nfi_cfop.key === '0') || (registro.nfi_cfop.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CFOP', });
      return;
    }
    if ((!registro.nficms_origem) || (registro.nficms_origem.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Origem', });
      return;
    }
    if ((!registro.nficms_modbc) || (registro.nficms_modbc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Modalidade', });
      return;
    }
    if ((!registro.nficms_cst) || (registro.nficms_cst.key === '0') || (registro.nficms_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST ICMS', });
      return;
    }
    if ((!registro.nfipi_cst) || (registro.nfipi_cst.key === '0') || (registro.nfipi_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST IPI', });
      return;
    }
    if ((!registro.nfipi_cst) || (registro.nfipi_cst.key === '0') || (registro.nfipi_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST PIS', });
      return;
    }
    if ((!registro.nfcof_cst) || (registro.nfcof_cst.key === '0') || (registro.nfcof_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST COFINS', });
      return;
    }
    if ((!registro.nfci_cst) || (registro.nfci_cst.key === '0') || (registro.nfci_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST IBS/CBS', });
      return;
    }
    if ((!registro.nfci_sit_trib_ibs_cbs) || (registro.nfci_sit_trib_ibs_cbs === '0') || (registro.nfci_sit_trib_ibs_cbs === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Situação Tributárias do IBS/CBS', });
      return;
    }

    const vlrTotalAux = parseFloat(registro.nfi_vlr_total);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
      return;
    }
    if (!registro.nfi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }



    let iIndItem = -1;
    if (registro.nfi_seq >= 0) {
      for (var x in listaProdutos) {
        if (String(listaProdutos[x].nfi_seq) === String(registro.nfi_seq)) {
          iIndItem = x;
        }
      }
    }

    // console.log('onOK', iIndItem, registro)

    if (parseInt(iIndItem) >= 0) {

      this.state.listaProdutos[iIndItem] = {
        ...this.state.listaProdutos[iIndItem],

        nfi_ncm: registro.nfi_ncm,
        nfi_cfop: registro.nfi_cfop.key,

        nfi_qtde: parseFloat(registro.nfi_qtde),
        nfi_vlr_unitario: parseFloat(registro.nfi_vlr_unitario),
        nfi_vlr_total: parseFloat(registro.nfi_vlr_total),
        nfi_perc_desconto: parseFloat(registro.nfi_perc_desconto === '' ? '0' : registro.nfi_perc_desconto),
        nfi_vlr_desconto: parseFloat(registro.nfi_vlr_desconto === '' ? '0' : registro.nfi_vlr_desconto),
        nfi_vlr_despesas: parseFloat(registro.nfi_vlr_despesas === '' ? '0' : registro.nfi_vlr_despesas),
        nfi_vlr_frete: 0,
        nfi_vlr_seguro: 0,

        nficms_cst: registro.nficms_cst.key,
        nficms_origem: registro.nficms_origem.key,
        nficms_modbc: registro.nficms_modbc.key,
        nficms_vbc: registro.nficms_vbc,
        nficms_picms: registro.nficms_picms,
        nficms_vicms: registro.nficms_vicms,
        nficms_vbcst: registro.nficms_vbcst,
        nficms_picmsst: registro.nficms_picmsst,
        nficms_vicmsst: registro.nficms_vicmsst,

        nfipi_cst: registro.nfipi_cst.key,
        nfipi_vbc: registro.nfipi_vbc,
        nfipi_pipi: registro.nfipi_pipi,
        nfipi_vipi: registro.nfipi_vipi,

        nfpis_cst: registro.nfpis_cst.key,
        nfpis_vbc: registro.nfpis_vbc,
        nfpis_ppis: registro.nfpis_ppis,
        nfpis_vpis: registro.nfpis_vpis,

        nfcof_cst: registro.nfcof_cst.key,
        nfcof_vbc: registro.nfcof_vbc,
        nfcof_pcofins: registro.nfcof_pcofins,
        nfcof_vcofinf: registro.nfcof_vcofinf,

        nfci_cst: registro.nfci_cst.key,
        nfci_sit_trib_ibs_cbs: registro.nfci_sit_trib_ibs_cbs,
        nfci_bc: registro.nfci_bc,
        nfci_pibs_mun: registro.nfci_pibs_mun,
        nfci_vibs_mun: registro.nfci_vibs_mun,
        nfci_pibs_est: registro.nfci_pibs_est,
        nfci_vibs_est: registro.nfci_vibs_est,
        nfci_pcbs: registro.nfci_pcbs,
        nfci_vcbs: registro.nfci_vcbs,
      };


    } else {


      this.state.listaProdutos.push({
        nfi_seq: this.state.listaProdutos.length + 1,
        nfi_produto: registro.nfi_produto.idf,
        nfi_prduto_codigo: registro.nfi_produto.cod,
        nfi_descricao_produto: registro.nfi_produto.descr,
        med_descricao: registro.nfi_produto.med_descricao,
        prod_cod_barras: registro.nfi_produto.prod_cod_barras,

        nfi_ncm: registro.nfi_ncm,
        nfi_cfop: registro.nfi_cfop.key,

        nfi_unid_medida: registro.nfi_produto.med_descricao,
        nfi_qtde: parseFloat(registro.nfi_qtde),
        nfi_vlr_unitario: parseFloat(registro.nfi_vlr_unitario),
        nfi_vlr_total: parseFloat(registro.nfi_vlr_total),
        nfi_perc_desconto: parseFloat(registro.nfi_perc_desconto === '' ? '0' : registro.nfi_perc_desconto),
        nfi_vlr_desconto: parseFloat(registro.nfi_vlr_desconto === '' ? '0' : registro.nfi_vlr_desconto),
        nfi_vlr_despesas: parseFloat(registro.nfi_vlr_despesas === '' ? '0' : registro.nfi_vlr_despesas),
        nfi_vlr_frete: 0,
        nfi_vlr_seguro: 0,

        prod_grade: registro.nfi_produto.prod_grade,
        nfi_item_tamanho: registro.nfi_produto.pest_tamanho,
        nfi_item_cor: registro.nfi_produto.pest_cor,
        ptam_descricao: registro.nfi_produto.ptam_descricao,
        pcor_descricao: registro.nfi_produto.pcor_descricao,

        nficms_cst: registro.nficms_cst.key,
        nficms_origem: registro.nficms_origem.key,
        nficms_modbc: registro.nficms_modbc.key,
        nficms_vbc: registro.nficms_vbc,
        nficms_picms: registro.nficms_picms,
        nficms_vicms: registro.nficms_vicms,
        nficms_vbcst: registro.nficms_vbcst,
        nficms_picmsst: registro.nficms_picmsst,
        nficms_vicmsst: registro.nficms_vicmsst,

        nfipi_cst: registro.nfipi_cst.key,
        nfipi_vbc: registro.nfipi_vbc,
        nfipi_pipi: registro.nfipi_pipi,
        nfipi_vipi: registro.nfipi_vipi,

        nfpis_cst: registro.nfpis_cst.key,
        nfpis_vbc: registro.nfpis_vbc,
        nfpis_ppis: registro.nfpis_ppis,
        nfpis_vpis: registro.nfpis_vpis,

        nfcof_cst: registro.nfcof_cst.key,
        nfcof_vbc: registro.nfcof_vbc,
        nfcof_pcofins: registro.nfcof_pcofins,
        nfcof_vcofinf: registro.nfcof_vcofinf,

        nfci_cst: registro.nfci_cst.key,
        nfci_sit_trib_ibs_cbs: registro.nfci_sit_trib_ibs_cbs,
        nfci_bc: registro.nfci_bc,
        nfci_pibs_mun: registro.nfci_pibs_mun,
        nfci_vibs_mun: registro.nfci_vibs_mun,
        nfci_pibs_est: registro.nfci_pibs_est,
        nfci_vibs_est: registro.nfci_vibs_est,
        nfci_pcbs: registro.nfci_pcbs,
        nfci_vcbs: registro.nfci_vcbs,
      });

    }

    this.props.onSalvarProdutoClick(this.state.listaProdutos);
  };




  onChangeProduto = event => {
    // console.log('onChangeProduto: ', event);

    const { registro, listaParCFOP } = this.state;

    registro['nfi_produto'] = event.nfi_produto;
    registro['nfi_ncm'] = event.nfi_produto.prod_ncm;
    registro['nfi_vlr_unitario'] = parseFloat(event.nfi_produto.vlrVenda);
    this.setState(event);

    this.calculoItem(registro.nfi_qtde, parseFloat(event.nfi_produto.vlrVenda), registro.nfi_perc_desconto, registro.nfi_vlr_desconto);

    const tipoProduto = event.nfi_produto.prod_tipo_produto ? event.nfi_produto.prod_tipo_produto : 1;

    for (var x in listaParCFOP) {

      if (listaParCFOP[x].pcfop_natureza === 'PRODUTO') {

        if (String(listaParCFOP[x].pcfop_tipo_mov_nf) === String(registro.tipo_mov_nf)) {

          if (String(listaParCFOP[x].pcfop_regime_contribuinte) === String(registro.tipo_contribuinte)) {

            if (String(listaParCFOP[x].pcfop_tipo_produto) === String(event.nfi_produto.prod_tipo_produto)) {

              if (String(registro.uf_destinatario) === String(this.state.usuario.cmun_uf)) {
                registro.nfi_cfop = { key: String(listaParCFOP[x].pcfop_cfop_dentro_uf), label: '' };
              } else if (String(registro.uf_destinatario) !== String(this.state.usuario.cmun_uf)) {
                registro.nfi_cfop = { key: String(listaParCFOP[x].pcfop_cfop_fora_uf), label: '' };
              } else if (!registro.uf_destinatario) {
                registro.nfi_cfop = { key: String(listaParCFOP[x].pcfop_cfop_estrangeiro), label: '' };
              } else {
                registro.nfi_cfop = { key: '5102', label: '' };
              }
              this.setState({
                registro
              });

            }
          }
        }
      }
    };

    this.setState({
      registro
    });
  }


  calculoItem = (nfi_qtde, nfi_vlr_unitario, nfi_perc_desconto, nfi_vlr_desconto) => {
    const { registro } = this.state;
    const vlrUnit = parseFloat(nfi_vlr_unitario);
    const qtde = parseFloat(nfi_qtde);

    // let percDesc = nfi_perc_desconto ? (parseFloat(nfi_perc_desconto) / 100) : 0;
    // let vlrDesc = 0;
    // vlrDesc = parseFloat((parseFloat(nfi_qtde) * parseFloat(vlrUnit)) * percDesc);
    // let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    let percDesc = parseFloat(nfi_perc_desconto);
    let vlrDesc = parseFloat(nfi_vlr_desconto);

    if (vlrDesc === 0) {
      percDesc = nfi_perc_desconto ? (parseFloat(nfi_perc_desconto) / 100) : 0;
      vlrDesc = parseFloat((parseFloat(nfi_qtde) * parseFloat(vlrUnit)) * percDesc);
    }

    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    if (registro.nficms_picms > 0) {
      registro.nficms_vbc = parseFloat(vlrTotal);
      registro.nficms_vicms = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nficms_picms) / 100)));
    }
    if (registro.nficms_picmsst > 0) {
      registro.nficms_vbcst = parseFloat(vlrTotal);
      registro.nficms_vicmsst = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nficms_picmsst) / 100)));
    }
    if (registro.nfipi_pipi > 0) {
      registro.nfipi_vbc = parseFloat(vlrTotal);
      registro.nfipi_vipi = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfipi_pipi) / 100)));
    }
    if (registro.nfpis_ppis > 0) {
      registro.nfpis_vbc = parseFloat(vlrTotal);
      registro.nfpis_vpis = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfpis_ppis) / 100)));
    }
    if (registro.nfcof_pcofins > 0) {
      registro.nfcof_vbc = parseFloat(vlrTotal);
      registro.nfcof_vcofinf = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfcof_pcofins) / 100)));
    }
    if (registro.nfci_pibs_mun > 0) {
      registro.nfci_bc = parseFloat(vlrTotal);
      registro.nfci_vibs_mun = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfci_pibs_mun) / 100)));
    }
    if (registro.nfci_pibs_est > 0) {
      registro.nfci_bc = parseFloat(vlrTotal);
      registro.nfci_vibs_est = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfci_pibs_est) / 100)));
    }
    if (registro.nfci_pcbs > 0) {
      registro.nfci_bc = parseFloat(vlrTotal);
      registro.nfci_vcbs = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfci_pcbs) / 100)));
    }

    registro.nfi_vlr_total = vlrTotal;
    registro.nfi_vlr_desconto = vlrDesc;
    this.setState({
      registro
    });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });

    // console.log('onChange', this.state)
    // console.log('onChange', event.target)


    if (id === 'nfi_qtde') {
      registro.nfi_vlr_total = parseFloat(((value * (parseFloat(registro.nfi_vlr_unitario))) - (parseFloat(registro.nfi_vlr_desconto)) + (parseFloat(registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_unitario') {
      registro.nfi_vlr_total = parseFloat(((value * (parseFloat(registro.nfi_qtde))) - (parseFloat(registro.nfi_vlr_desconto)) + (parseFloat(registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_despesas') {
      registro.nfi_vlr_total = parseFloat((((parseFloat(registro.nfi_qtde)) * (parseFloat(registro.nfi_vlr_unitario))) - (parseFloat(registro.nfi_vlr_desconto)) + (value)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_perc_desconto') {
      const percDesc = value / 100;
      const vlrDesc = parseFloat((parseFloat(registro.nfi_vlr_unitario) * parseFloat(registro.nfi_qtde)) * percDesc);

      registro.nfi_vlr_desconto = vlrDesc;
      registro.nfi_vlr_total = parseFloat((((parseFloat(registro.nfi_qtde)) * (parseFloat(registro.nfi_vlr_unitario))) - (vlrDesc) + (parseFloat(registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_desconto') {
      registro.nfi_vlr_total = parseFloat((((parseFloat(registro.nfi_qtde)) * (parseFloat(registro.nfi_vlr_unitario))) - (value) + (parseFloat(registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    }

    if ((id === 'nfi_qtde') || (id === 'nfi_vlr_unitario') || (id === 'nfi_vlr_despesas') || (id === 'nfi_perc_desconto') || (id === 'nfi_vlr_desconto')) {
      if (registro.nficms_picms > 0) {
        registro.nficms_vbc = parseFloat(registro.nfi_vlr_total);
        registro.nficms_vicms = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nficms_picms) / 100)));
      }
      if (registro.nficms_picmsst > 0) {
        registro.nficms_vbcst = parseFloat(registro.nfi_vlr_total);
        registro.nficms_vicmsst = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nficms_picmsst) / 100)));
      }
      if (registro.nfipi_pipi > 0) {
        registro.nfipi_vbc = parseFloat(registro.nfi_vlr_total);
        registro.nfipi_vipi = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfipi_pipi) / 100)));
      }
      if (registro.nfpis_ppis > 0) {
        registro.nfpis_vbc = parseFloat(registro.nfi_vlr_total);
        registro.nfpis_vpis = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfpis_ppis) / 100)));
      }
      if (registro.nfcof_pcofins > 0) {
        registro.nfcof_vbc = parseFloat(registro.nfi_vlr_total);
        registro.nfcof_vcofinf = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfcof_pcofins) / 100)));
      }
      if (registro.nfci_pibs_mun > 0) {
        registro.nfci_bc = parseFloat(registro.nfi_vlr_total);
        registro.nfci_vibs_mun = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfci_pibs_mun) / 100)));
      }
      if (registro.nfci_pibs_est > 0) {
        registro.nfci_bc = parseFloat(registro.nfi_vlr_total);
        registro.nfci_vibs_est = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfci_pibs_est) / 100)));
      }
      if (registro.nfci_pcbs > 0) {
        registro.nfci_bc = parseFloat(registro.nfi_vlr_total);
        registro.nfci_vcbs = parseFloat((parseFloat(registro.nfi_vlr_total) * (parseFloat(registro.nfci_pcbs) / 100)));
      }
    }


    if (id === 'nficms_vbc') {
      registro.nficms_vicms = parseFloat((value * (parseFloat(registro.nficms_picms) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_picms') {
      registro.nficms_vicms = parseFloat((parseFloat(registro.nficms_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_vbcst') {
      registro.nficms_vicmsst = parseFloat((value * (parseFloat(registro.nficms_picmsst) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_picmsst') {
      registro.nficms_vicmsst = parseFloat((parseFloat(registro.nficms_vbcst) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfipi_vbc') {
      registro.nfipi_vipi = parseFloat((value * (parseFloat(registro.nfipi_pipi) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfipi_pipi') {
      registro.nfipi_vipi = parseFloat((parseFloat(registro.nfipi_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfpis_vbc') {
      registro.nfpis_vpis = parseFloat((value * (parseFloat(registro.nfpis_ppis) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfpis_ppis') {
      registro.nfpis_vpis = parseFloat((parseFloat(registro.nfpis_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfcof_vbc') {
      registro.nfcof_vcofinf = parseFloat((value * (parseFloat(registro.nfcof_pcofins) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfcof_pcofins') {
      registro.nfcof_vcofinf = parseFloat((parseFloat(registro.nfcof_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });

    } else if (id === 'nfci_bc') {
      registro.nfci_vibs_mun = parseFloat((value * (parseFloat(registro.nfci_pibs_mun) / 100)).toFixed(2));
      registro.nfci_vibs_est = parseFloat((value * (parseFloat(registro.nfci_pibs_est) / 100)).toFixed(2));
      registro.nfci_vcbs = parseFloat((value * (parseFloat(registro.nfci_pcbs) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pibs_mun') {
      registro.nfci_vibs_mun = parseFloat((parseFloat(registro.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pibs_est') {
      registro.nfci_vibs_est = parseFloat((parseFloat(registro.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pcbs') {
      registro.nfci_vcbs = parseFloat((parseFloat(registro.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    }
  };










  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalProdutoClick, visivel } = this.props;

    const { editando, OPCOES_COMBO_CFOP } = this.state;
    const { nfi_seq, nfi_produto, nfi_descricao_produto, nfi_ncm, nfi_cfop, nficms_origem, nficms_modbc,
      nfi_qtde, nfi_vlr_unitario, nfi_perc_desconto, nfi_vlr_desconto, nfi_vlr_despesas, nfi_vlr_total,
      nficms_cst, nficms_vbc, nficms_picms, nficms_vicms, nficms_vbcst, nficms_picmsst, nficms_vicmsst,
      nfipi_cst, nfipi_vbc, nfipi_pipi, nfipi_vipi, nfpis_cst, nfpis_vbc, nfpis_ppis, nfpis_vpis,
      nfcof_cst, nfcof_vbc, nfcof_pcofins, nfcof_vcofinf,
      nfci_cst, nfci_sit_trib_ibs_cbs, nfci_bc, nfci_pibs_mun, nfci_vibs_mun, nfci_pibs_est, nfci_vibs_est, nfci_pcbs, nfci_vcbs
    } = this.state.registro;

    // console.log('NotaFiscalItemForm.this.state: ', this.state);

    return (
      <Modal
        title={editando ? "Editar Produto da Nota" : "Incluir Produto da Nota"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalProdutoClick}
        footer={null}
        width={"50%"}
        style={{ top: 20 }}
      >
        <div>

          <Row>
            <Col xs={24} >
              {nfi_seq ? (
                <div>
                  <span>Produto</span>
                  <InputForm
                    id="nfi_descricao_produto"
                    ref="nfi_descricao_produto"
                    maxLength={9}
                    onChange={this.onChange}
                    value={nfi_descricao_produto}
                    disabled={true}
                  />
                </div>
              ) : (
                <ProdutoFrame
                  label="Produto"
                  id="nfi_produto"
                  value={nfi_produto}
                  width={"100%"}
                  onChange={this.onChangeProduto}
                />
              )}
            </Col>
            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }} >
              <span>NCM</span>
              <InputForm
                id="nfi_ncm"
                ref="nfi_ncm"
                maxLength={9}
                onChange={this.onChange}
                value={nfi_ncm}
              />
            </Col>
            <Col xs={24} sm={20} style={{ marginTop: -20 }}>
              <span>CFOP</span>
              <InputForm
                type="select"
                id="nfi_cfop"
                ref="nfi_cfop"
                value={nfi_cfop}
                placeholder="Selecione o CFOP"
                onChange={this.onChange}
                data={OPCOES_COMBO_CFOP}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>
            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde</span>
              <InputForm
                type="number"
                id="nfi_qtde"
                ref="nfi_qtde"
                value={nfi_qtde}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Unitário</span>
              <InputForm
                type="number"
                id="nfi_vlr_unitario"
                ref="nfi_vlr_unitario"
                value={nfi_vlr_unitario}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20 }}>
              <span>Valor Despesas</span>
              <InputForm
                type="number"
                id="nfi_vlr_despesas"
                ref="nfi_vlr_despesas"
                value={nfi_vlr_despesas}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Desc (%)</span>
              <InputForm
                type="number"
                id="nfi_perc_desconto"
                ref="nfi_perc_desconto"
                value={nfi_perc_desconto}
                onChange={this.onChange}
              />
            </Col>
            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Desconto</span>
              <InputForm
                type="number"
                id="nfi_vlr_desconto"
                ref="nfi_vlr_desconto"
                value={nfi_vlr_desconto}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20 }}>
              <span>Valor Total</span>
              <InputForm
                type="number"
                id="nfi_vlr_total"
                ref="nfi_vlr_total"
                value={nfi_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>

          <Row>
            <Collapse>
              <Panel header={<span style={{ fontSize: 20, fontWeight: 'bold' }}>Impostos</span>} key="1">
                <Col xs={24} sm={24} style={{ marginTop: 0 }} >
                  <span>Origem</span>
                  <InputForm
                    type="select"
                    id="nficms_origem"
                    ref="nficms_origem"
                    value={nficms_origem}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_ORIGEM}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>

                <Col xs={24} sm={24} style={{ marginTop: -20 }} >
                  <span>Modalidade</span>
                  <InputForm
                    type="select"
                    id="nficms_modbc"
                    ref="nficms_modbc"
                    value={nficms_modbc}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_MODALIDADE}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>


                <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                  <span>CST ICMS</span>
                  <InputForm
                    type="select"
                    id="nficms_cst"
                    ref="nficms_cst"
                    value={nficms_cst}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_CST_ICMS}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC ICMS</span>
                  <InputForm
                    type="number"
                    id="nficms_vbc"
                    ref="nficms_vbc"
                    value={nficms_vbc}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita ICMS</span>
                  <InputForm
                    type="number"
                    id="nficms_picms"
                    ref="nficms_picms"
                    value={nficms_picms}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <span>Valor ICMS</span>
                  <InputForm
                    type="number"
                    id="nficms_vicms"
                    ref="nficms_vicms"
                    value={nficms_vicms}
                    disabled={true}
                  />
                </Col>

                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC ICMS ST</span>
                  <InputForm
                    type="number"
                    id="nficms_vbcst"
                    ref="nficms_vbcst"
                    value={nficms_vbcst}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita ICMS ST</span>
                  <InputForm
                    type="number"
                    id="nficms_picmsst"
                    ref="nficms_picmsst"
                    value={nficms_picmsst}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <span>Valor ICMS ST</span>
                  <InputForm
                    type="number"
                    id="nficms_vicmsst"
                    ref="nficms_vicmsst"
                    value={nficms_vicmsst}
                    disabled={true}
                  />
                </Col>


                <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                  <span>CST IPI</span>
                  <InputForm
                    type="select"
                    id="nfipi_cst"
                    ref="nfipi_cst"
                    value={nfipi_cst}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_CST_IPI}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC IPI</span>
                  <InputForm
                    type="number"
                    id="nfipi_vbc"
                    ref="nfipi_vbc"
                    value={nfipi_vbc}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita IPI</span>
                  <InputForm
                    type="number"
                    id="nfipi_pipi"
                    ref="nfipi_pipi"
                    value={nfipi_pipi}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <span>Valor IPI</span>
                  <InputForm
                    type="number"
                    id="nfipi_vipi"
                    ref="nfipi_vipi"
                    value={nfipi_vipi}
                    disabled={true}
                  />
                </Col>


                <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                  <span>CST PIS</span>
                  <InputForm
                    type="select"
                    id="nfpis_cst"
                    ref="nfpis_cst"
                    value={nfpis_cst}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_CST_PIS}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC PIS</span>
                  <InputForm
                    type="number"
                    id="nfpis_vbc"
                    ref="nfpis_vbc"
                    value={nfpis_vbc}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita PIS</span>
                  <InputForm
                    type="number"
                    id="nfpis_ppis"
                    ref="nfpis_ppis"
                    value={nfpis_ppis}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <span>Valor PIS</span>
                  <InputForm
                    type="number"
                    id="nfpis_vpis"
                    ref="nfpis_vpis"
                    value={nfpis_vpis}
                    disabled={true}
                  />
                </Col>


                <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                  <span>CST COFINS</span>
                  <InputForm
                    type="select"
                    id="nfcof_cst"
                    ref="nfcof_cst"
                    value={nfcof_cst}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_CST_COFINS}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC COFINS</span>
                  <InputForm
                    type="number"
                    id="nfcof_vbc"
                    ref="nfcof_vbc"
                    value={nfcof_vbc}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita COFINS</span>
                  <InputForm
                    type="number"
                    id="nfcof_pcofins"
                    ref="nfcof_pcofins"
                    value={nfcof_pcofins}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <span>Valor COFINS</span>
                  <InputForm
                    type="number"
                    id="nfcof_vcofinf"
                    ref="nfcof_vcofinf"
                    value={nfcof_vcofinf}
                    disabled={true}
                  />
                </Col>


                <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                  <span>CST IBS/CBS</span>
                  <InputForm
                    type="select"
                    id="nfci_cst"
                    ref="nfci_cst"
                    value={nfci_cst}
                    placeholder="Selecione"
                    onChange={this.onChange}
                    data={OPCOES_COMBO_CST_IBS_CBS}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }} >
                  <span>Situação Tributária</span>
                  <InputForm
                    id="nfci_sit_trib_ibs_cbs"
                    ref="nfci_sit_trib_ibs_cbs"
                    maxLength={9}
                    onChange={this.onChange}
                    value={nfci_sit_trib_ibs_cbs}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>BC IBS/CBS</span>
                  <InputForm
                    type="number"
                    id="nfci_bc"
                    ref="nfci_bc"
                    value={nfci_bc}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita IBS Mun.</span>
                  <InputForm
                    type="number"
                    id="nfci_pibs_mun"
                    ref="nfci_pibs_mun"
                    value={nfci_pibs_mun}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>Valor IBS Mun.</span>
                  <InputForm
                    type="number"
                    id="nfci_vibs_mun"
                    ref="nfci_vibs_mun"
                    value={nfci_vibs_mun}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita IBS Est.</span>
                  <InputForm
                    type="number"
                    id="nfci_pibs_est"
                    ref="nfci_pibs_est"
                    value={nfci_pibs_est}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Valor IBS Est.</span>
                  <InputForm
                    type="number"
                    id="nfci_vibs_est"
                    ref="nfci_vibs_est"
                    value={nfci_vibs_est}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Alíquita CBS</span>
                  <InputForm
                    type="number"
                    id="nfci_pcbs"
                    ref="nfci_pcbs"
                    value={nfci_pcbs}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>Valor CBS</span>
                  <InputForm
                    type="number"
                    id="nfci_vcbs"
                    ref="nfci_vcbs"
                    value={nfci_vcbs}
                    disabled={true}
                  />
                </Col>

              </Panel>
            </Collapse>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                {this.props.produtoSelecionado && this.props.produtoSelecionado.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onFecharModalProdutoClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotaFiscalItemForm.js